/** True when the browser sends the Global Privacy Control opt-out signal. */
export function isGlobalPrivacyControlEnabled(): boolean {
    return typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true;
}
